<template>
  <div class="promo section" :style="{backgroundImage: 'url('+get_image()+')'}">
    <div class="container">
      <div class="row">
        <div class="col-6 col-xs-12"></div>
        <div class="col-6 col-xs-12">
          <div class="promo-block">
            <h2>{{banner.title}}</h2>
            <p>{{banner.description}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['banner'],
  i18n: {
    messages: {
      en: {
        title: 'here are many variations of passages of Lorem Ipsum available',
        description: 'It is a long established fact that a reader will be distracte by the readable content of a page when looking at its layout.',
        button: 'SIGN UP'
      },
      hy: {
        title: 'here are many variations of passages of Lorem Ipsum available',
        description: 'It is a long established fact that a reader will be distracte by the readable content of a page when looking at its layout.',
        button: 'Գրանցվել'
      }
    }
  },
  data () {
    return {
      image: '/img/promo-banner.jpg',
      mobile_image: '/img/promo-mobile-banner.jpg'
    }
  },
  methods: {
    get_image(){
      return ['xs', 'sm', 'ms'].includes(this.$mq) ? this.banner.mobile_image : this.banner.image
    }
  }
}
</script>

<style lang="scss">
.promo {
  background-color: #000000;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  padding-top: 120px;
  padding-bottom: 120px;

  @include mq($lg) {
    padding-top: 300px;
    padding-bottom: 15px;
  }

  .promo-block {
    max-width: 650px;
    float: right;
    h2 {
      font-size: 46px;
      margin-top: 0;
      margin-bottom: 20px;
      text-transform: uppercase;

      @include mq($lg) {
        font-size: 24px;
      }
    }
    p {
      margin-top: 0;
      margin-bottom: 30px;

      @include mq($ms) {
        margin-bottom: 0;
      }
    }
  }
}
</style>
